import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import "./uploadImages.css";

const UploadImages = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedUrls, setUploadedUrls] = useState([]); // State to store uploaded URLs and previews

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const filesWithPreview = Array.from(files).map((file) => ({
        file,
        preview: URL.createObjectURL(file), // Generate preview URL
      }));
      setSelectedFiles(filesWithPreview);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedFiles.length === 0) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "الرجاء اختيار ملف أولاً",
        confirmButtonText: "حسناً",
      });
      return;
    }

    setIsUploading(true);

    try {
      const uploadedData = [];

      // Upload each file individually
      for (const fileObj of selectedFiles) {
        const formData = new FormData();
        formData.append("file", fileObj.file);

        const response = await axios.post(
          "https://api.generalhome.sa/api/Themes/UploadImages",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // Extract the URL from the response data
        const imageUrl = response.data;

        // Store the URL and its corresponding preview
        uploadedData.push({ url: imageUrl, preview: fileObj.preview });
      }

      // Add all uploaded URLs and previews to the uploadedUrls state
      setUploadedUrls((prevUrls) => [...prevUrls, ...uploadedData]);

      Swal.fire({
        icon: "success",
        title: "تم!",
        text: "تم رفع الصور بنجاح!",
        confirmButtonText: "حسناً",
      });
    } catch (error) {
      console.error("Error uploading files:", error);
      Swal.fire({
        icon: "error",
        title: "خطأ!",
        text: "حدث خطأ أثناء رفع الصور",
        confirmButtonText: "حسناً",
      });
    } finally {
      setIsUploading(false);
    }
  };

  // Function to copy URL to clipboard
  const copyToClipboard = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "تم النسخ!",
          text: "تم نسخ الرابط بنجاح",
          confirmButtonText: "حسناً",
        });
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "خطأ!",
          text: "تعذر نسخ الرابط",
          confirmButtonText: "حسناً",
        });
      });
  };

  return (
    <div className="upload-images-container">
      <h2>رفع الصور</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="image-upload">اختر الصور:</label>
          <input
            type="file"
            id="image-upload"
            name="image"
            accept="image/*"
            onChange={handleFileChange}
            multiple
          />
        </div>
        <button type="submit" disabled={isUploading}>
          {isUploading ? "جاري الرفع..." : "رفع الصور"}
        </button>
      </form>

      {/* Display uploaded URLs and previews */}
      {uploadedUrls.length > 0 && (
        <div className="uploaded-urls">
          <h3>روابط الصور المرفوعة:</h3>
          <ul>
            {uploadedUrls.map((item, index) => (
              <li key={index}>
                <div className="preview-container">
                  <img
                    src={item.preview}
                    alt={`Preview ${index}`}
                    className="image-preview"
                  />
                  <span>{item.url}</span>
                </div>
                <button onClick={() => copyToClipboard(item.url)}>
                  نسخ الرابط
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UploadImages;
